<template>
  <div>
    <!-- 顶部步骤 -->
    <div class="step-line">
      <div class="step-item" :class="{ active: sendStep == 1 }">
        <span class="step-num">1</span>
        <span class="step-text">筛选会员</span>
      </div>
      <div class="step-division"></div>
      <div class="step-item" :class="{ active: sendStep == 2 }">
        <span class="step-num">2</span>
        <span class="step-text">编辑短信</span>
      </div>
    </div>
    <!-- 按条件，分组筛选数据 -->
    <div class="condition-group" v-if="sendStep == 1">
      <div class="tab-line">
        <div
          class="tab-item"
          :style="{ color: tabIndex == '1' ? globalBG : '' }"
          @click="switchTab(1)"
        >
          按条件筛选<span
            :style="{ 'background-color': tabIndex == '1' ? globalBG : '' }"
          ></span>
        </div>
        <div
          class="tab-item"
          :style="{ color: tabIndex == '2' ? globalBG : '' }"
          @click="switchTab(2)"
        >
          按分组筛选<span
            :style="{ 'background-color': tabIndex == '2' ? globalBG : '' }"
          ></span>
        </div>
      </div>

      <!-- 按条件筛选 -->
      <div class="condition-box" v-if="tabIndex == '1'">
        <el-form
          :inline="true"
          ref="ListForm"
          :model="addFormData"
          class="demo-form-inline"
        >
          <el-form-item label="职业:" label-width="150px">
            <el-checkbox-group v-model="addFormData.crowdPortraitType">
              <el-checkbox
                v-for="(item, index) in worker_all"
                :label="item.value"
                :key="index"
              >
                {{ item.label }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item label="会员等级:" label-width="150px">
            <el-checkbox v-model="levelUnlimited" @change="switchLevel('0')"
              >不限</el-checkbox
            >
            <el-checkbox-group
              v-model="addFormData.grades"
              @change="switchLevel('1')"
              style="display: inline-block; margin-left: 20px"
            >
              <el-checkbox
                v-for="(item, index) in gradesList"
                :label="item.value"
                :key="index"
              >
                {{ item.label }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item label="交易总额:" label-width="150px">
            <el-radio-group v-model="addFormData.totalPayment">
              <el-radio
                v-for="(item, index) in totalPaymentList"
                :key="index"
                :label="item.value"
              >
                {{ item.label }}
                <div v-if="item.value == '-1'" style="display: inline-block">
                  <el-input
                    placeholder="请输入..."
                    :disabled="!(addFormData.totalPayment == '-1')"
                    v-model="addFormData.startBuyTotalMoney"
                  ></el-input>
                  <span class="to">至</span>
                  <el-input
                    placeholder="请输入..."
                    :disabled="!(addFormData.totalPayment == '-1')"
                    v-model="addFormData.endBuyTotalMoney"
                  ></el-input>
                  <span class="company">元</span>
                </div>
              </el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="购买次数:" label-width="150px">
            <el-radio-group v-model="addFormData.buyTotalCount">
              <el-radio label="">不限</el-radio>
              <el-radio :label="0">0次</el-radio>
              <el-radio :label="1">1次</el-radio>
              <el-radio :label="2">2次</el-radio>
              <el-radio :label="3">3次以上</el-radio>
              <el-radio :label="-1"
                >自定义
                <el-input
                  placeholder="请输入..."
                  :disabled="!(addFormData.buyTotalCount == '-1')"
                  v-model="addFormData.startBuyTotalCount"
                ></el-input>
                <span class="to">至</span>
                <el-input
                  placeholder="请输入..."
                  :disabled="!(addFormData.buyTotalCount == '-1')"
                  v-model="addFormData.endBuyTotalCount"
                ></el-input>
                <span class="company">次</span>
              </el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="平均客单价:" label-width="150px">
            <el-radio-group v-model="addFormData.averagePricement">
              <el-radio
                v-for="(item, index) in totalPaymentList"
                :key="index"
                :label="item.value"
              >
                {{ item.label }}
                <div v-if="item.value == '-1'" style="display: inline-block">
                  <el-input
                    placeholder="请输入..."
                    :disabled="!(addFormData.averagePricement == '-1')"
                    v-model="addFormData.startAvgPrice"
                  ></el-input>
                  <span class="to">至</span>
                  <el-input
                    placeholder="请输入..."
                    :disabled="!(addFormData.averagePricement == '-1')"
                    v-model="addFormData.endAvgPrice"
                  ></el-input>
                  <span class="company">元</span>
                </div>
              </el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="首次交易时间:" label-width="150px">
            <el-radio-group v-model="addFormData.buyerFirstTime">
              <el-radio label="">不限</el-radio>
              <el-radio label="week">近7天</el-radio>
              <el-radio label="oneMonth">近一个月</el-radio>
              <el-radio label="threeMonth">近三个月</el-radio>
              <el-radio label="sixMonth">近半年</el-radio>
              <el-radio label="Customized"
                >自定义
                <div class="my_select_time">
                  <el-date-picker
                    prefix-icon="no_icon"
                    :disabled="addFormData.buyerFirstTime != 'Customized'"
                    v-model="addFormData.startBuyerFirstTime"
                    type="datetime"
                    :placeholder="'选择日期时间'"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    style="width: 120px; font-size: 12px"
                    class="time1"
                    :clearable="false"
                  ></el-date-picker>
                  <div class="time_to_text" :class="{'to_text_disabled': addFormData.buyerFirstTime != 'Customized'}" >至</div>
                  <el-date-picker
                    prefix-icon="no_icon"
                    v-model="addFormData.endBuyerFirstTime"
                    type="datetime"
                    :placeholder="'选择日期时间'"
                    size="small"
                    :disabled="addFormData.buyerFirstTime != 'Customized'"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    style="width: 145px; font-size: 12px"
                    class="time2"
                    :clearable="false"
                  ></el-date-picker>
                  <i
                    class="el-icon-circle-close date_icon1"
                    @click="clearTimeSendTime1()"
                  ></i>
                  <img
                    src="@/assets/images/select_date.svg"
                    alt
                    class="date_icon2"
                  />
                </div>
                <span class="company">天</span>
              </el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="最后交易时间:" label-width="150px">
            <el-radio-group v-model="addFormData.buyerLastTime">
              <el-radio label="">不限</el-radio>
              <el-radio label="week">近7天</el-radio>
              <el-radio label="oneMonth">近一个月</el-radio>
              <el-radio label="threeMonth">近三个月</el-radio>
              <el-radio label="sixMonth">近半年</el-radio>

              <el-radio label="Customized"
                >自定义
                <div class="my_select_time">
                  <el-date-picker
                    prefix-icon="no_icon"
                    :disabled="addFormData.buyerLastTime != 'Customized'"
                    v-model="addFormData.startBuyerLastTime"
                    type="datetime"
                    :placeholder="'选择日期时间'"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    style="width: 120px; font-size: 12px"
                    class="time1"
                    :clearable="false"
                  ></el-date-picker>
                  <div class="time_to_text" :class="{'to_text_disabled': addFormData.buyerLastTime != 'Customized'}">至</div>
                  <el-date-picker
                    prefix-icon="no_icon"
                    v-model="addFormData.endBuyerLastTime"
                    type="datetime"
                    :placeholder="'选择日期时间'"
                    size="small"
                    :disabled="addFormData.buyerLastTime != 'Customized'"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    style="width: 145px; font-size: 12px"
                    class="time2"
                    :clearable="false"
                  ></el-date-picker>
                  <i
                    class="el-icon-circle-close date_icon1"
                    @click="clearTimeSendTime2()"
                  ></i>
                  <img
                    src="@/assets/images/select_date.svg"
                    alt
                    class="date_icon2"
                  />
                </div>

                <span class="company">天</span>
              </el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="所在地区:" label-width="150px">
            <el-radio-group v-model="addFormData.province">
              <el-radio label @change="cityRadioChange('')">全部</el-radio>
              <el-tooltip
                content="江苏省、浙江省、上海"
                placement="bottom"
                effect="light"
              >
                <el-radio label="JZH" @change="cityRadioChange('JZH')"
                  >江浙沪</el-radio
                >
              </el-tooltip>
              <el-tooltip
                content="新疆、西藏、云南省、青海省"
                placement="bottom"
                effect="light"
              >
                <el-radio
                  label="RemoteArea"
                  @change="cityRadioChange('RemoteArea')"
                  >偏远地区</el-radio
                >
              </el-tooltip>
              <el-radio
                label="Customized"
                @change="cityRadioChange('Customized')"
                >自定义</el-radio
              >

              <!-- <el-radio :label="1">江浙沪</el-radio> -->
              <!-- <el-radio :label="2">偏远地区（疆藏云海）</el-radio> -->
              <!-- <el-radio :label="''">自定义
                  <el-button type="danger" plain>已选择0个</el-button>
                </el-radio> -->
            </el-radio-group>
            <el-button
              type="danger"
              @click="changeCityShow"
              v-if="addFormData.province == 'Customized'"
              plain
              >已选择{{ checkedList.length }}个</el-button
            >
          </el-form-item>

          <!-- <el-form-item label="指定商品件数:"
                label-width="150px">   
                <el-select v-model="addFormData.xxx6">
                  <el-option value="0" label="全部"></el-option>
                  <el-option value="1" label="指定"></el-option>
                </el-select>
                <el-input placeholder="请输入..." v-model="addFormData.minValue1"></el-input>
                  <span class="to">至</span>
                  <el-input placeholder="请输入..." v-model="addFormData.maxValue1"></el-input>
                  <span class="company">件</span>
          </el-form-item>  -->

          <el-form-item label="指定sku:" label-width="150px">
            <el-radio-group v-model="skuType">
              <el-radio :label="0">
                选择sku
                <el-button class="search" @click="handleShowGoods(true)">已选择{{skuList.length}}个</el-button>
              </el-radio>
              <el-radio :label="1">
                输入sku
                <el-input
                  style="width: 280px"
                  v-model="addFormData.skuIds"
                  placeholder="多个SKU之间用英文逗号隔开"
                ></el-input>
              </el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="商品编码:" label-width="150px">
            <el-radio-group v-model="wareType">
              <el-radio :label="0">
                商品编码
                <el-button class="search" @click="handleShowGoods(false)">已选择{{wareList.length}}个</el-button>
              </el-radio>
              <el-radio :label="1">
                输入商品编码
                <el-input
                  style="width: 280px"
                  v-model="addFormData.wareIds"
                  placeholder="多个商品编码之间用英文逗号隔开"
                ></el-input>
              </el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="选择标签:" label-width="150px">
            <el-radio-group v-model="addFormData.labelType">
              <el-radio label="">不限</el-radio>
              <el-radio :label="1"
                >指定
                <el-button
                  v-if="addFormData.labelType == 1"
                  type="danger"
                  plain
                  @click="showLabelDialog('1')"
                  style="font-size: 14px"
                  >已选择{{ incluseLableIds.length }}个</el-button
                >
              </el-radio>
              <el-radio :label="2"
                >排除<el-button
                  v-if="addFormData.labelType == 2"
                  type="danger"
                  plain
                  @click="showLabelDialog('2')"
                  style="font-size: 14px"
                  >已选择{{ excludeLableIds.length }}个</el-button
                >
              </el-radio>
              <el-radio :label="3">无标签</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <!-- 按分组筛选 -->
      <div class="group-box" v-if="tabIndex == '2'">
        <div class="select-type">
          <span>选择类型：</span>
          <el-radio-group
            v-model="groupParam.type"
            @change="getShopBuyerGroupList1"
          >
            <el-radio label="">全部</el-radio>
            <el-radio :label="0">我的分组</el-radio>
            <el-radio :label="1"
              >系统分组<el-button type="primary" v-zoom='{from:pageName,name:"创建分组"}'
                >去创建分组</el-button
              ></el-radio
            >
          </el-radio-group>
        </div>
        <div class="table-box">
          <el-table
            :data="groupData"
            v-loading="groupLoading || reLoading"
            :header-cell-style="{ background: '#FAFAFA' }"
            @selection-change="handleSelectionChange"
            tooltip-effect="light"
            ref="groupData"
          >
            <el-table-column label="" width="70px">
              <template slot-scope="scope">
                <!-- <el-radio v-model="radioCheck" :label="scope.row.id" -->
                <el-radio @change="handleSelectGroup" v-model="radioCheck" :label="scope.$index"
                  >&nbsp;</el-radio
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="groupName"
              label="分组名称"
            ></el-table-column>
            <el-table-column
              prop="buyerNumString"
              label="客户数(人)"
            ></el-table-column>
            <el-table-column prop="type" label="分组来源">
              <template slot-scope="scope">
                {{ scope.row.type == "0" ? "我的分组" : "" }}
                {{ scope.row.type == "1" ? "系统分组" : "" }}
                {{ scope.row.type == "2" ? "高级分组" : "" }}
              </template>
            </el-table-column>
            <el-table-column prop="instruction" label="说明"></el-table-column>
            <el-table-column prop="crtime" label="创建时间"></el-table-column>
          </el-table>
          <div style="text-align: right; margin-top: 20px">
            <el-pagination
              background
              @size-change="handleSizeChangs"
              @current-change="handleCurrentChange"
              :page-sizes="[10, 20, 30, 50, 100, 500]"
              :page-size="groupParam.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              :current-page="groupParam.current"
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <!-- 底部 -->
      <div class="foot-box" v-loading="memberLoading">
        <p class="txt">
          <el-button
            v-zoom='{from:pageName,name:"筛选会员"}'
            type="primary"
            style="font-size: 14px"
            @click="getMemberList(1)"
            >筛选会员</el-button
          >
          <el-button
            class="chakan_buttun"
            @click="getMemberList(2)"
            style="font-size: 14px"
            >查看会员</el-button
          >
          <span>共筛选出</span>
          <span :style="{ color: globalBG }">{{ totalMember }}</span>
          <span>会员</span>
        </p>
        <!-- <el-button class="foot-btn">返回上一步</el-button> -->
        <el-button class="foot-btn" type="primary" v-zoom='{from:pageName,name:"编辑短信"}' @click="nextStep"
          >下一步，编辑短信</el-button
        >
      </div>
    </div>

    <!-- 编辑短信 -->
    <div class="send-message-box" v-if="sendStep == 2">
      <send-message-x
        @onViewRecord="handleViewRecord"
        @lastStep="lastStep"
        :preSendType="preSendType"
        :conditionNum="totalMember"
        :conditionParam="conditionParam"
        :reSendSmsObj="smsDataObj"
        :sendType="2"
      ></send-message-x>
    </div>

    <!-- 选择标签弹窗 -->
    <buyer-label-dialog
      v-if="isShowLabelDialog"
      :data="dialogLabelIds"
      :checkedArr="incluseLableIds"
      @onClose="handleCloseLabel"
    ></buyer-label-dialog>

    <!-- 查看会员弹窗 -->
    <view-buyer-dialog
      v-if="showViewBuyerDialog"
      @close="showViewBuyerDialog = false"
      :param="bugyerParam"
    ></view-buyer-dialog>

    <city-popover
      v-model="cityShow"
      :checkedList="checkedList"
      @on-change="getLocation"
    ></city-popover>

      <!-- 选择商品弹窗 -->
    <select-goods
      v-if="isShowGoods"
      :isShow="isShowGoods"
      :selectGoods="returnSelectGoods"
      :skuSearch="skuSearch"
      @close="selectGoodsChange"
      :moduleType="true"
    ></select-goods>
  </div>
</template>

<script>
import cityPopover from "@/components/city-popover-x.vue";
import selectGoods from "@/components/selectGoodsMonitor2";
import { getShopBuyer } from "@/api/shopBuyer.js";
import { getShopBuyerGroup } from "@/api/shopBuyerGroup";
import sendMessageX from "@/components/send-message-x.vue";
import buyerLabelDialog from "@/components/buyer-label-dialog.vue";
import viewBuyerDialog from "@/components/view-buyer-dialog.vue";

import { mapState } from "vuex";
export default {
  name: "member_send",
  computed: {
    ...mapState({
      globalBG: "globalBG",
      //   把city映射给currentCIty
    }),
  },
  props: {
    isReMarket: {
      type: Boolean,
      default: false, // 是否为再次营销发送
    },
    smsDataObj: { // 短信内容信息
      type: Object,
      default: () => {}
    },
    filterDataObj: { // 条件过滤信息
      type: Object,
      default: () => {},
    },
  },
  components: {
    sendMessageX,
    buyerLabelDialog,
    viewBuyerDialog,
    cityPopover,
    selectGoods
  },
  data() {
    return {
      isShowGoods: false,
      pageName:"客户营销-会员发送",
      skuType: 0, // 0.表示指定商品  1.表示输入sku
      wareType: 0, // 0.表示商品编码 1.表示输入sku
      radioCheck: 0, // 会员分组id  
      sendStep: 1,
      tabIndex: 1, // 1.按条件筛选  2.按分组筛选
      levelUnlimited: true, // 会员等级， 不限制
      addFormData: {
        crowdPortraitType: [],
        grades: [],
        totalPayment: "", // 交易金额
        startBuyTotalMoney: "",
        endBuyTotalMoney: "",
        buyTotalCount: "", // 购买次数
        startBuyTotalCount: "",
        endBuyTotalCount: "",
        averagePricement: "", // 平均客单价
        startAvgPrice: "",
        endAvgPrice: "",
        buyerFirstTime: "", // 首次交易时间
        startBuyerFirstTime: "",
        endBuyerFirstTime: "",
        buyerLastTime: "", // 最后交易时间
        startBuyerLastTime: "",
        endBuyerLastTime: "",
        skuIds: "", // 指定skuId组
        labelType: "", // 1指定，2排除 3.无标签
        labelIds: [],
        province: "", // 地区
        wareIds: "", // 指定商品编码
      },

      incluseLableIds: [], // 指定标签
      excludeLableIds: [], // 排除标签
      labelTypeDialog: 1, // 1.表示指定类型 2.表示排序类型
      dialogLabelIds: [], // 回显标签数据

      // selectType: 1, // 选择类型
      // tableLoading: false,

      gradesList: [
        {
          value: 1,
          label: "一星会员",
        },
        {
          value: 2,
          label: "二星会员",
        },
        {
          value: 3,
          label: "三星会员",
        },
        {
          value: 4,
          label: "四星会员",
        },
        {
          value: 5,
          label: "五星会员",
        },
      ],
      totalPaymentList: [
        {
          label: "不限",
          value: "",
        },
        {
          label: "0-100",
          value: "OneAndHundred",
        },
        {
          label: "100-200",
          value: "HundredAndTwoHundred",
        },
        {
          label: "200-300",
          value: "TwoHundredAndThreeHundred",
        },
        {
          label: "300以上",
          value: "ThreeHundredTheAbove",
        },
        {
          label: "自定义",
          value: "-1",
        },
      ],
      isShowLabelDialog: false,
      memberLoading: false, // 计算会员人群
      totalMember: 0,

      // 会员分组
      groupLoading: false,
      reLoading: false,
      groupParam: {
        size: 10,
        current: 1,
        type: 0, // 0，
      },
      groupData: [],
      total: 0,
      showViewBuyerDialog: false,
      bugyerParam: {},
      conditionParam: {},
      preSendType: 1, // 测试短信预提交参数1.表示条件， 3.表示会员分组
      checkedList: [],
      cityShow: false,
      skuList: [],
      wareList: [],
      returnSelectGoods: [],
      skuSearch: true,
      totalPages: 0,
    };
  },
  
  mounted() {
    // this.getShopBuyerGroupList();
    console.log(this.$route.query.type);
    // this.groupParam.type = this.$route.query.type==3?:0;
    this.initData();
  },
  methods: {
    getLocation(val, state) {
      if (state == 'cancel') {
        return
      }
      this.checkedList = val;
    },
    handleSelectGroup() {
      this.totalMember = 0;
    },
    initData() {
      if (this.$route.query.type == 1) {
        this.groupParam.type = "";
        this.preSendType = 3
      }
      if (this.$route.query.type == 2) {
        this.groupParam.type = 1;
        this.preSendType = 3
      }
      this.groupParam.current = Number(this.$route.query.current) || 1;
      this.groupParam.size = Number(this.$route.query.size) || 10;
      this.tabIndex = this.$route.query.tabIndex || 1;
      this.radioCheck = this.$route.query.groupName - 1;
      // this.radioCheck = +this.$route.query.groupId || '';
     
      this.addFormData.labelType = this.$route.query.labelType ? 1 : "";
      // this.incluseLableIds = this.$route.query.incluseLableIds;
      if (this.$route.query.incluseLableIds != null) {
        let mes = this.$route.query.incluseLableIds.split(" ");
        this.incluseLableIds = mes;
        this.dialogLabelIds = this.incluseLableIds;
        // console.log(typeof(this.dialogLabelIds));
      }
      // 近多少天有交易
      if (this.$route.query.day == 1) {
        this.addFormData.buyerLastTime = "Customized"; //R≤30天
        this.fun_date(-30, 0);
      }
      if (this.$route.query.day == 2) {
        this.addFormData.buyerLastTime = "Customized"; //30<R≤90
        this.fun_date(-90, -30);
      }
      if (this.$route.query.day == 3) {
        this.addFormData.buyerLastTime = "Customized"; //90<R≤180
        this.fun_date(-180, -90);
      }
      if (this.$route.query.day == 4) {
        this.addFormData.buyerLastTime = "Customized"; //180<R≤360
        this.fun_date(-360, -180);
      }
      if (this.$route.query.day == 5) {
        this.addFormData.buyerLastTime = "Customized"; //R>360
        this.fun_date(0, -360);
      }
      // 标准分析-购买次数
      if (this.$route.query.number == 0) {
        this.addFormData.buyTotalCount = 1;
      }
      if (this.$route.query.number == 1) {
        this.addFormData.buyTotalCount = 2;
      }
      if (this.$route.query.number == 2) {
        this.addFormData.buyTotalCount = -1;
        this.addFormData.startBuyTotalCount = 3;
        this.addFormData.endBuyTotalCount = 3;
      }
      if (this.$route.query.number == 3) {
        this.addFormData.buyTotalCount = -1;
        this.addFormData.startBuyTotalCount = 4;
        this.addFormData.endBuyTotalCount = 4;
      }
      if (this.$route.query.number == 4) {
        this.addFormData.buyTotalCount = -1;
        this.addFormData.startBuyTotalCount = 5;
      }
      //最近一次购买时间
      if (this.$route.query.index == 0) {
        this.addFormData.buyerLastTime = "Customized"; // R≤7
        this.fun_date(-7, 0);
      }
      if (this.$route.query.index == 1) {
        this.addFormData.buyerLastTime = "Customized"; //7 < R  ≤30
        this.fun_date(-30, -7);
      }
      if (this.$route.query.index == 2) {
        this.addFormData.buyerLastTime = "Customized"; //30 < R  ≤90
        this.fun_date(-90, -30);
      }
      if (this.$route.query.index == 3) {
        this.addFormData.buyerLastTime = "Customized"; // 90 < R  ≤120
        this.fun_date(-120, -90);
      }
      if (this.$route.query.index == 4) {
        this.addFormData.buyerLastTime = "Customized"; // R>120
        this.fun_date(0, -120);
      }
      // 购买次数
      if (this.$route.query.index == 5) {
        this.addFormData.buyTotalCount = 0;
      }
      if (this.$route.query.index == 6) {
        this.addFormData.buyTotalCount = 1;
      }
      if (this.$route.query.index == 7) {
        this.addFormData.buyTotalCount = 2;
      }
      if (this.$route.query.index == 8) {
        this.addFormData.buyTotalCount = -1;
        this.addFormData.startBuyTotalCount = 3;
      }
      // 会员发送再次营销条件回显
      if (this.isReMarket) {
        var obj = this.filterDataObj;
        if (obj.sendType == '1') {
          // 按条件查询
          if (obj.crowdPortraitType && obj.crowdPortraitType.length > 0) {
            obj.crowdPortraitType = obj.crowdPortraitType.map((item) => {
              return '' + item;
            })
          }
          if (obj.grades && obj.grades.length > 0) {
            this.levelUnlimited = false;
            obj.grades = obj.grades.map(item => {
              return +item;
            })
          }
          var totalPayment = (obj.startBuyTotalMoney || obj.endBuyTotalMoney) ? '-1' : (obj.totalPayment || '');
          var buyTotalCount = (obj.startBuyTotalCount || obj.endBuyTotalCount) ? '-1' : obj.buyTotalCount;
          var averagePricement = (obj.startAvgPrice || obj.endAvgPrice) ? '-1' : (obj.averagePricement || '');
          if (obj.skuIds) {
            this.skuType = 1;
          }
          if (obj.wareIds) {
            this.wareType = 1;
          }
          if (obj.labelIds && obj.labelIds.length > 0) {
            obj.labelIds = obj.labelIds.map(item => {
              return +item;
            })
            if (obj.labelType == '1') {
              // 指定
              this.incluseLableIds = obj.labelIds;
            } else if (obj.labelType == '2') {
              // 排除
              this.excludeLableIds = obj.labelIds;
            }
          }

          this.addFormData = {
            crowdPortraitType: obj.crowdPortraitType || [],
            grades: obj.grades || [],
            totalPayment: totalPayment, // 交易金额
            startBuyTotalMoney: obj.startBuyTotalMoney !== null ? obj.startBuyTotalMoney: "",
            endBuyTotalMoney: obj.endBuyTotalMoney !== null ? obj.endBuyTotalMoney: "",
            buyTotalCount: buyTotalCount !== undefined ? +buyTotalCount : '', // 购买次数
            startBuyTotalCount: obj.startBuyTotalCount !== null ? obj.startBuyTotalCount: "",
            endBuyTotalCount: obj.endBuyTotalCount !== null ? obj.endBuyTotalCount: "",
            averagePricement: averagePricement, // 平均客单价
            startAvgPrice: obj.startAvgPrice !== null ? obj.startAvgPrice: "",
            endAvgPrice: obj.endAvgPrice !== null ? obj.endAvgPrice: "",
            buyerFirstTime: obj.buyerFirstTime || "", // 首次交易时间
            startBuyerFirstTime: obj.startBuyerFirstTime || "",
            endBuyerFirstTime: obj.endBuyerFirstTime || "",
            buyerLastTime: obj.buyerLastTime || "", // 最后交易时间
            startBuyerLastTime: obj.startBuyerLastTime || "",
            endBuyerLastTime: obj.endBuyerLastTime || "",
            skuIds: (obj.skuIds && obj.skuIds.join(',')) || "", // 指定skuId组
            wareIds: (obj.wareIds && obj.wareIds.join(",")) || "", // 指定商品编码
            labelType: obj.labelType || "", // 1指定，2排除 3.无标签
            labelIds: obj.labelIds || [],
            province: obj.province || "", // 地区
          }
          if (obj.province == 'Customized') {
            // this.checkedList = obj.customArea || [];
            this.checkedList = obj.cites.split(',') || [];
          }
          this.switchTab(1);
          this.getShopBuyerGroupList();
        } else if (obj.sendType == '3') {
          // 按会员分组
          var groupId = obj.shopBuyerGroupId;
          this.switchTab(2);
          this.getCurrentGroup(groupId)
        }
      } else {
         this.getShopBuyerGroupList();
      }
    },

    handleShowGoods(flag) {
      this.skuSearch = flag;
      this.isShowGoods = true;
      if (flag) {
        // skuid 
        this.returnSelectGoods = this.skuList;
      } else {
        // 商品 id
        this.returnSelectGoods = this.wareList;
      }
    },

    selectGoodsChange(val) {
      console.log(val);
      this.isShowGoods = false;
      if (val) {
        // var wareIds = []
        // val.forEach(item => {
        //   wareIds.push(item.wareId)
        // })
        if (this.skuSearch) {
          this.skuList = val;
        } else {
          this.wareList = val;
          // this.addFormData.wareIds = wareIds;
        }
      }
    },
    // 日期回显
    fun_date(aa, bb) {
      let date1 = new Date(),
        time1 =
          date1.getFullYear() +
          "-" +
          (date1.getMonth() + 1) +
          "-" +
          date1.getDate(); //time1表示当前时间
      if (aa != 0) {
        let date2 = new Date(date1);
        date2.setDate(date1.getDate() + aa);
        let time2 =
          date2.getFullYear() +
          "-" +
          (date2.getMonth() + 1) +
          "-" +
          date2.getDate();
        this.addFormData.startBuyerLastTime = time2 + " 00:00:00";
      } else {
        this.addFormData.startBuyerLastTime = "";
      }
      if (bb != undefined) {
        let date3 = new Date(date1);
        date3.setDate(date1.getDate() + bb);
        let time3 =
          date3.getFullYear() +
          "-" +
          (date3.getMonth() + 1) +
          "-" +
          date3.getDate();
        this.addFormData.endBuyerLastTime = time3 + " 00:00:00";
      }
    },
    //清除时间函数
    clearTimeSendTime1() {
      this.addFormData.endBuyerFirstTime = "";
      this.addFormData.startBuyerFirstTime = "";
    },
    clearTimeSendTime2() {
      this.addFormData.endBuyerLastTime = "";
      this.addFormData.startBuyerLastTime = "";
    },
    handleViewRecord() {
      this.$emit("onViewRecord");
    },
    //点击自定义时是否显示
    changeCityShow() {
      this.cityShow = true;
    },

    cityRadioChange(value) {
      this.addFormData.province = value;
      if (value == "") {
        this.checkedList = [];
        this.cityShow = false;
      } else if (value == "JZH") {
      } else if (value == "RemoteArea") {
      } else if (value == "Customized") {
        // this.checkedList = [];
        // this.cityShow = true;
      }
      console.log("this.checkedList:", this.checkedList);
    },
    // 会员分组选择
    handleSelectionChange(val) {
      console.log(val);
    },
    // 查询会员分组列表
    getShopBuyerGroupList() {
      var param = this.groupParam;
      this.groupLoading = true;
      getShopBuyerGroup(param).then((res) => {
        this.groupLoading = false;
        if (res.code == "1") {
          this.groupData = res.data.records;
          this.total = +res.data.total;
          this.totalMember = 0
        }
      });
    },
    // 通过分组id 查询改id 位于哪一页
    async getCurrentGroup(id) {
      this.reLoading = true;
      this.groupParam.type = '';
      console.log('id:====', id)
      this.groupParam.current = 1;
      await getShopBuyerGroup(this.groupParam).then((res) => {
        this.totalPages = res.data.pages;
        this.total = +res.data.total;
        this.groupData = res.data.records;
      })

      this.groupParam.current = 0;
      for (var i = 0; i < this.totalPages; i++ ) {
        this.groupParam.current = this.groupParam.current + 1;
        console.log('this.groupParam.current:', this.groupParam.current)
        var param = this.groupParam;
        
        var flag = false;
        let flagIndex = '';
        await getShopBuyerGroup(this.groupParam).then((res) => {
          var list = res.data.records;
          this.groupData = list;
          flag = list.find((item, index) => {
            flagIndex = index;
            return item.id === id;
          })
        })
       
        if (flag) {
          this.radioCheck = flagIndex;
          break;
        }
      }
      this.reLoading = false;
    },

    getShopBuyerGroupList1(){
      this.groupParam.current = 1;
      this.getShopBuyerGroupList();
    },
    // 查询会员列表数据 type == 1; 表示筛选会员 2.表示查看会员
    getMemberList(type) {
      if (type == "2") {
        if (this.totalMember == "0") {
          this.$message.warning("请先筛选会员！");
          return;
        }
      }

      var param = null;
      if (this.tabIndex == "1") {
        // 按条件筛选
        param = JSON.parse(JSON.stringify(this.addFormData));
        // debugger
        if (this.skuType === 0) {
          var skuIdList = [];
          this.skuList.forEach(item => {
            skuIdList.push(item.skuId)
          })
          param.skuIds = skuIdList.join(',')
        }
        if (this.wareType === 0) {
          var wareIds = [];
          this.wareList.forEach(item => {
            wareIds.push(item.wareId)
          })
          param.wareIds = wareIds.join(',')
        }
        if (param.totalPayment == "-1") {
          // 交易金额 自定义
          param.totalPayment = "";
        } else {
          param.startBuyTotalMoney = "";
          param.endBuyTotalMoney = "";
        }

        if (param.buyTotalCount == "-1") {
          // 购买次数 自定义
          param.buyTotalCount = "";
        } else {
          param.startBuyTotalCount = "";
          param.endBuyTotalCount = "";
        }

        if (param.averagePricement == "-1") {
          // 评价客单价 自定义
          param.averagePricement = "";
        } else {
          param.startAvgPrice = "";
          param.endAvgPrice = "";
        }
        if (param.province === "Customized") {
          // 自定义地区
          // param.customArea = this.checkedList;
          param.cites = this.checkedList.join(',');
        }
        // debugger
        if (param.skuIds.length > 0) {
          if (param.skuIds.indexOf(",") != "-1") {
            param.skuIds = param.skuIds.split(",");
          } else {
            param.skuIds = [param.skuIds];
          }
        } else {
          param.skuIds = [];
        }

        if (param.wareIds.length > 0) {
          if (param.wareIds.indexOf(",") != "-1") {
            param.wareIds = param.wareIds.split(",");
          } else {
            param.wareIds = [param.wareIds];
          }
        } else {
          param.wareIds = [];
        }


        if (param.labelType == "1") {
          // 指定
          param.labelIds = this.incluseLableIds;
        } else if (param.labelType == "2") {
          param.labelIds = this.excludeLableIds;
        }
      } else {
        // 按分组筛选
        var selectItem = this.groupData[this.radioCheck];
        // var selectItem = this.groupData.find(item =>{
        //   return item.id == this.radioCheck
        // });
        
        param = {
          whereJsonDTO: selectItem.whereJsonDTO,
          labelType: 1,
        };
      }
      param.size = 10;
      param.current = 1;
      if (this.tabIndex == "1") {
        this.conditionParam = param;
      } else {
        this.conditionParam = {
          shopBuyerGroupId: this.groupData[this.radioCheck].id,
          // shopBuyerGroupId: this.radioCheck,
        };
      }

      this.bugyerParam = param;
      this.memberLoading = true;
      getShopBuyer(param).then((res) => {
        this.memberLoading = false;
        if (res.code == "1") {
          this.totalMember = res.data.total;
          if (type == "2") {
            this.showViewBuyerDialog = true;
          }
        }
      });
    },

    showLabelDialog(val) {
      this.labelTypeDialog = val;
      if (val == "1") {
        this.dialogLabelIds = this.incluseLableIds;
      } else {
        this.dialogLabelIds = this.excludeLableIds;
      }
      this.isShowLabelDialog = true;
    },
    handleCloseLabel(val, ids) {
      
      if(!ids){
        ids =[]
      }
      console.log(val,"ids" ,ids)
        if(val){
          if (this.labelTypeDialog == "1") {
          // 指定
          this.incluseLableIds = ids;
          console.log(this.incluseLableIds.length)
          } else if(this.labelTypeDialog == "2"){
            // 排除
            this.excludeLableIds = ids;
            console.log(this.excludeLableIds.length)

          }
        }
      // console.log(this.incluseLableIds)
      // console.log(this.excludeLableIds)
      // console.log("ids",ids.length)
      this.isShowLabelDialog = false;
    },

    switchLevel(type) {
      if (type == "0") {
        this.addFormData.grades = [];
      } else if (type == "1") {
        this.levelUnlimited = false;
      }
    },

    handleSizeChangs(val) {
      this.groupParam.size = val;
      this.getShopBuyerGroupList();
    },
    handleCurrentChange(val) {
      this.groupParam.current = val;
      this.getShopBuyerGroupList();
    },
    nextStep() {
      if (this.totalMember >= 2) {
        this.sendStep = 2;
      } else {
        this.$message.warning("京东官方规定人数少于2无法发送，请增加营销人数");
      }
    },
    // 返回上一步
    lastStep() {
      console.log("lastStep");
      this.sendStep = 1;
    },
    switchTab(index) {
      this.tabIndex = index;
      if (index == "1") {
        this.preSendType = 1;
      } else {
        this.preSendType = 3;
      }
      this.totalMember = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.search {
  color: rgb(254, 77, 69);
  background-color: #ffffff;
  border-radius: 3px;
  border: 1px solid rgb(254, 77, 69);
  font-size: 14px;
}
.search:hover {
  color: #ffffff;
  background-color: rgb(254, 77, 69);
}
.el-form-item--small.el-form-item {
  display: block;
  margin-bottom: 16px;
}
/deep/.send-message-box {
  .main_content {
    padding-top: 40px;
  }
}
.group-box {
  padding: 14px 28px;
  .table-box {
    margin-top: 44px;
  }
}
.foot-box {
  flex: 0 0 80px;
  margin-top: 139px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding-left: 28px;
  border-top: 1px solid #f0f0f0;
  flex-shrink: 0;
  height: 80px;
  line-height: 80px;
  .chakan_buttun {
    width: 98px;
    height: 32px;
    color: #fe4d45;
    margin-right: 8px;
    border: 1px solid #fe4d45;
    background-color: #fff;
    &:hover {
      color: #fff;
      border: 1px solid #fff;
      background-color: #fe4d45;
    }
  }
  .txt {
    color: #333;
    font-size: 14px;
    margin-right:545px;
     @media screen and (max-width: 1366px) {
margin-right:400px;
        }
    .el-button {
      // margin-right: 8px;
    }
  }
  .foot-btn {
    width: 166px;
    height: 36px;
    font-size: 14px;
    border-radius: 3px;
  }
}

.condition-group {
  // box-shadow:0px 4px 8px rgba(0,0,0,0.1);
  border-radius: 6px;
  background-color: #fff;
  margin: 20px;
  .tab-line {
    padding-left: 28px;
    .tab-item {
      display: inline-block;
      font-size: 14px;
      color: #999999;
      padding: 15px 0;
      font-weight: 400;
      margin-right: 24px;
      cursor: pointer;
      position: relative;
      span {
        position: absolute;
        width: 70px;
        height: 2px;
        left: 50%;
        transform: translateX(-50%);
        bottom: 1px;
      }
      &.active {
        font-weight: 500;
      }
    }
    border-bottom: 1px solid #f6f6f6;
  }
  .condition-box {
    padding-top: 74px;
  }
  .el-input {
    width: 125px;
  }
  .el-select {
    width: 136px;
    margin-right: 12px;
  }
  .company {
    padding-left: 8px;
  }
  .to {
    padding: 0 8px;
  }
  .el-button {
    margin-left: 8px;
  }
}

.step-line {
  margin: 11px 20px 0 20px;
  text-align: center;
  padding: 24px 0;
  border-bottom: 1px solid #f3f3f3;
  margin-bottom: 24px;
  background: #fafafa;
  border-radius: 38px;
  .step-item {
    color: #999999;
    vertical-align: middle;
    display: inline-block;
    .step-num {
      display: inline-block;
      width: 24px;
      height: 24px;
      text-align: center;
      line-height: 24px;
      font-size: 14px;
      border-radius: 24px;
      border: 1px solid #cccccc;
      margin-right: 8px;
    }
    .step-text {
      font-size: 16px;
    }
    &.active {
      .step-text {
        font-weight: 500;
        color: #333;
      }
      .step-num {
        background: linear-gradient(
          180deg,
          rgba(255, 109, 110, 1) 0%,
          rgba(254, 51, 59, 1) 100%
        );
        border-radius: 50%;
        border-color: #fe333b;
        color: #fff;
      }
    }
  }
  .step-division {
    display: inline-block;
    width: 240px;
    height: 1px;
    background: rgba(0, 0, 0, 0.15);
    vertical-align: middle;
    margin: 0 8px;
  }
}
</style>
